import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";

import styles from "assets/jss/material-dashboard-react/components/customTabsStyle.js";
import { Box, IconButton, Typography, useMediaQuery } from "@material-ui/core";
import { fieldAgentTabsName } from "assets/properties/properties";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const useStyles = makeStyles(styles);


function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function ControlTab(props) {
  const [value, setValue] = React.useState(0);
  // const handleChange = (event, value) => {
  //     setValue(value);
  const smallScreen = useMediaQuery("(max-width: 1000px)");
  // };
  const classes = useStyles();
  const { headerColor, plainTabs, tabs, title, rtlActive, currentTab, substatus, status, enabledInsurance , fieldAgent, handleClose, featureFlags} = props;
  const cardTitle = classNames({
    [classes.cardTitle]: true,
    [classes.cardTitleRTL]: rtlActive,
  });
  if (currentTab !== value) {
    setValue(currentTab);
  }
  console.log(substatus,"enabledInsuranceenabledInsurance3333333333333333")
  let newTabs =[];
  if(substatus ==="PRE_PLEDGE"){
      newTabs = tabs.filter((item)=> item.tabName !== "Loan Details" && item.tabName !== fieldAgentTabsName?.repaymentSchdule && item.tabName !== "Sanction Letter Part-A" && item.tabName !== "Esign Part-A" && item.tabName !== "Sanction Letter Part-B" && item.tabName !== "Esign Part-B" && item.tabName !== "Insurance Eligiblity" && item.tabName !== "Insurance Letter" && item.tabName !== "Insurance E-sign")
  }else if(substatus ==="POST_PLEDGE"){
    newTabs = tabs.filter((item)=> item.tabName !== "BT Kit" && item.tabName !== "Upload Kit")
  }
  else{
      newTabs = tabs.filter((item)=>item.tabName !== "Lender Details " && item.tabName !== "Pawan Ticket Details" && item.tabName !== "BT Kit" && item.tabName !== "Upload Kit")
  }
  if(!enabledInsurance){
    newTabs = newTabs.filter((item) => item.tabName !== "Insurance Eligiblity" && item.tabName !== "Insurance Letter" && item.tabName !== "Insurance E-sign");
  }
  return (
    <>
    <Card plain={plainTabs}>
        <>
        <Tabs
          value={value}
          // onChange={handleChange}
          classes={{
            root: classes.tabsRoot,
            indicator: classes.displayNone,
            scrollButtons: classes.displayNone,
          }}
          className={classes.container}
          orientation={smallScreen ? "horizonal" : "vertical"} 
          variant="scrollable"
          scrollButtons="auto"
        >
          {newTabs.map((prop, key) => {
            var icon = {};
            if (prop.icon) {
              icon = {
                icon:  <img src={prop.icon} alt={""} className={classNames(classes.itemIcon)}></img>,
              };
            }
            return (
                <Tab
                  classes={{
                    root: classes.tabRootButton,
                    selected: classes.tabSelected,
                    wrapper: classes.tabWrapper,
                  }}
                  style={{marginBottom:fieldAgent ? '8px' : '20px'}}
                  key={key}
                  label={prop.tabName}
                  className={classes.itemText}
                  {...icon}
                />
            )
          })}
        </Tabs>
        </>
        {newTabs.map((prop, key) => {
          if (key === value) {
            return (
              <div
                key={key}
                role="tabpanel"
                hidden={value !== key}
                id={`vertical-tabpanel-${key}`}
                aria-labelledby={`vertical-tab-${key}`}
                className={classes.container1}
                style={{height: fieldAgent ? 'calc(100vh - 200px)': '100%', overflowY:'auto', position:'relative'}}
              >
                {value === key && (
                  <Box sx={{ p: 3 }}> 
                  {prop.tabContent}
                </Box>
                )}
                {fieldAgent && (
                  smallScreen ? (
                  <IconButton
                    onClick={() => handleClose()}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      backgroundColor: "#fff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                      zIndex: 10,
                      padding: "8px",
                    }}
                  >
                    <ArrowBackIcon style={{ color: "#000", fontSize: "24px" }} />
                  </IconButton>
                  ) : (
                    <div
                      role="button"
                      className={classes.nextButton}
                      onClick={() => handleClose()}
                      style={{
                        display: "flex",
                        marginRight: "10%",
                        justifyContent: "right",
                        position: "absolute",
                        top: "3%",
                        right: "0",
                      }}
                    >
                      Back To Home
                    </div>
                  )
                )}
                </div>
            )
          }
          return null;
        })}
       
    </Card>
    </>
  );
}

ControlTab.propTypes = {
  headerColor: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose",
  ]),
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.string,
      tabIcon: PropTypes.object,
      tabContent: PropTypes.node,
    })
  ),
  rtlActive: PropTypes.bool,
  plainTabs: PropTypes.bool,
  currentTab: PropTypes.object,
};
